import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import Swal from "sweetalert2";

import FormInput from "../components/forminput";
import FormTextArea from "../components/formtextarea";

const AdminEtapa = (props) => {
  const municipio = props.municipio;
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      etapa: municipio.etapa,
      tituloHome: municipio.tituloHome,
      msjHome: municipio.msjHome,
      msjProp: municipio.msjProp,
    },
  });

  const onSubmit = (data) => {
    axios
      .put(`api/municipios/${municipio._id}`, data)
      .then((res) => {
        //Redireccionar
        const municipioRes = res.data.municipioActualizado;
        if (municipioRes.etapa === "votacion") {
          axios.post(`api/votaciones/${municipio._id}`);
        }
        Swal.fire("Se actualizó con exito la información", "", "success");
        props.history.push(`/consola`);
      })
      .catch((err) => {
        Swal.fire(
          "Ocurrió un error, por favor inténtelo de nuevo o pónganse en contacto.",
          "",
          "error"
        );
      });
  };

  if (!municipio) return null;

  return (
    <Fragment>
      <div className="row">
        <div className="col-md-12">
          <h4 className="ppr-titulo centrado my-2">Administrar Etapa</h4>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 mx-auto">
          <form className="m-3" onSubmit={handleSubmit(onSubmit)}>
            <div className="from-group mb-3">
              <label htmlFor="etapa">Etapa:</label>
              <select
                {...register("etapa")}
                className="form-control"
                id="etapa"
              >
                <option value="informativa">Informativa</option>
                <option value="presentacion">Presentación</option>
                <option value="votacion">Votación</option>
                <option value="seleccion">Selección</option>
              </select>
            </div>

            <FormInput
              register={register}
              error={errors.tituloHome}
              label={"Título :"}
              id={"tituloHome"}
              isRequired={true}
              placeholder="Título del mensaje en la página de inicio."
            />

            <FormTextArea
              register={register}
              error={errors.msjHome}
              label={"Mensaje :"}
              id={"msjHome"}
              isRequired={true}
              placeholder="Mensaje en la página de inicio."
              rows={4}
            />

            <FormTextArea
              register={register}
              error={errors.msjProp}
              label={"Mensaje Para Todas Las Propuestas:"}
              id={"msjProp"}
              isRequired={false}
              placeholder="Mensaje que se publica en todas las páginas de las propuestas."
              rows={4}
            />

            <center>
              <button
                type="submit"
                className="btn ppr-btn-azul font-weight-bold m-2 mr-5"
              >
                Guardar Cambios
              </button>
            </center>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(AdminEtapa);
